// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen2_comp__rZ_xq"};